import { Tabs } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { AppHeader } from '@/components/AppHeader';
import { HomesteadTabBar } from '@/components/TabBar';
import { Palette } from '@/constants/theme';

export default function TabsLayout() {
  return (
    <View style={styles.shell}>
      <SafeAreaView edges={['top']} style={styles.headerShell}>
        <AppHeader />
      </SafeAreaView>
      <View style={styles.tabsWrap}>
        <Tabs
          tabBar={(props) => <HomesteadTabBar {...props} />}
          screenOptions={{ headerShown: false }}>
          <Tabs.Screen name="index" options={{ title: 'Today' }} />
          <Tabs.Screen name="schedule" options={{ title: 'Schedule' }} />
          <Tabs.Screen name="my-home" options={{ title: 'My Home' }} />
          <Tabs.Screen name="settings" options={{ title: 'Settings' }} />
        </Tabs>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  shell: { flex: 1, backgroundColor: Palette.sand },
  headerShell: { backgroundColor: Palette.sand },
  tabsWrap: { flex: 1 },
});
